import transformProps from '@didi/webx-ui-utils/src/transform-props'
import config from '../../../views/index/config'

const props = {
  info: {
    type: Object,
    value: () => config,
  },
  pageConfig: {
    type: Object,
    value: () => ({
      index: {
        style: {
          backgroundColor: '#c3170d',
        },
        button: {
          text: '立即领取',
          gotoText: '去使用',
        },
        showStation: true,
        link: 'https://didi.cn/avKDrvq',
        title: '滴滴加油券天天领',
      },
      station: {
        link: 'https://didi.cn/j1zpaqg',
      },
      redPacket: {
        _closeTitle: '加油福利券包1',
      },
      rule: {
        link: '',
        style: {
          top: 80,
          color: '#FFFFFF',
          backgroundColor: 'rgba(0,0,0,.3)',
        },
      },
      popup: {
        button: {
          text: '去使用',
        },
      },
      header: {},
      imageList: [
        {
          image:
            'https://ut-static.udache.com/webx/ut/Qug32EhMvHRRpl32ht4JQ.jpg',
          style: {
            marginTop: 0,
            width: 750,
          },
        },
        {
          image:
            'https://ut-static.udache.com/webx/ut/LOThgMUv_dxLThjQntwDx.png',
          style: {
            marginTop: 40,
            width: 700,
          },
        },
      ],
    }),
  },
}

const mockIndex = {
  errno: 0,
  errmsg: '',
  traceid: '123',
  data: {
    group: {
      id: '1e32e345456454',
      status: 1,
    },
    sign_in_infos: [
      {
        count: 10,
        is_sign_in: true,
        is_today: false,
        max_count: 20,
        desc: '领福利金 +10',
      },
      {
        count: 110,
        is_sign_in: true,
        is_today: false,
        max_count: 0,
        desc: '领福利金 +10',
      },
      {
        count: 110,
        is_sign_in: true,
        is_today: false,
        max_count: 0,
        desc: '领福利金 +10',
      },
      {
        count: 110,
        is_sign_in: true,
        is_today: false,
        max_count: 0,
        desc: '领福利金 +10',
      },
      {
        count: 110,
        is_sign_in: true,
        is_today: false,
        max_count: 0,
        desc: '领福利金 +10',
      },
      {
        count: 110,
        is_sign_in: true,
        is_today: true,
        max_count: 0,
        desc: '已领福利金',
      },
      {
        count: 110,
        is_sign_in: false,
        is_today: false,
        max_count: 0,
        desc: '没福利金，啥都没有',
      },
    ],
    rewards: [
      {
        type: 'coupon',
        coupon: {
          usage_limit: '满￥200可用',
          valid_period: '有效期截止2021.12.24',
          name: '加油福利券',
          type: 1,
          max_benefit_capacity: {
            value: 9,
            unit: '元',
          },
        },
      },
      {
        type: 'coupon',
        coupon: {
          usage_limit: '满￥300可用',
          valid_period: '有效期截止2021.12.25',
          name: '加油福利券',
          type: 3,
          max_benefit_capacity: {
            value: 19,
            unit: '元',
          },
        },
      },
      {
        type: 'coupon',
        coupon: {
          usage_limit: '满￥200可用',
          valid_period: '有效期截止2021.12.26',
          name: '加油福利券',
          type: 3,
          max_benefit_capacity: {
            value: 299,
            unit: '元',
          },
        },
      },
      {
        type: 'coupon',
        coupon: {
          usage_limit: '满￥200可用',
          valid_period: '有效期截止2021.12.27',
          name: '加油福利券',
          type: 100,
          max_benefit_capacity: {
            value: 8.9,
            unit: '折',
          },
        },
      },
    ],
    activity_info: {
      id: 1,
      has_saved_poster: false,
      save_poster_bonus: 3,
      rewards: [
        {
          type: 'coupon',
          coupon: {
            name: '加油福利券',
            usage_limit: '',
            valid_period: '',
            type: 1,
            max_benefit_capacity: {
              value: 20,
              unit: '元',
            },
          },
        },
      ],
    },
  },
}

const { propsForView, propsForModel, propsForStory } = transformProps(props)

export { props, propsForView, propsForModel, propsForStory, mockIndex }
